import { SVGAttributes } from 'react'

import SVGIcon from '@/components/base/svg-icon'

export type LogoProps = SVGAttributes<SVGSVGElement>

const Logo = ({ ...props }: LogoProps) => {
  return <SVGIcon symbol="logo" className="h-[2.6rem] w-[13rem]" {...props} />
}

export default Logo
